import {useContext, useState, useRef, useEffect} from "react";
import {AnimatePresence, motion} from "framer-motion";
import { dataContext } from "../../../context/context";
import './regions.css';



function Regions() {
    const { data, loading, error, isBY, isRU, isLocal } = useContext(dataContext);
    const [showItems, setShowItems] = useState(false);
    const [regionIndex, setRegionIndex] = useState(0);


        const section = data.sectionsdata.find(s => s.nick === 'regions');

        const regions = data ? data.regionsdata : [];
        const regionClass = isBY ? "region-country__by" : "region-country__ru";


        return (

            <motion.section
                layout
                id="regions"
                className={regionClass}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true, amount: 0.25 }}
                transition={{ duration: 0.25, delay: 0.5 }}
                onAnimationComplete={() => {
                    setShowItems(true);
                }}
            >
                <AnimatePresence mode="wait">
            <h2>{section.title}</h2>

                {


                regionIndex === 0 ? (

                    <motion.div
                        key="regions"
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -10 }}
                        transition={{ duration: 1 }}

                    >

                    {  regions.map((region, index) => (

                        <motion.div
                            key={index}
                            className="button button__region"
                            initial={{ opacity: 0, x: 1000 }}
                            animate={ showItems ? { opacity: 1, x: 0 } : {}}
                            transition={{ delay: index * 0.1, duration: 0.3 }}
                            onClick={() => setRegionIndex(region.id)}
                        >{region.name}</motion.div>

                        )) }

                        </motion.div>

                ) : (

                    <motion.div
                        key="cities" // Другой ключ для экрана городов
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -100 }}
                        transition={{ duration: 0.25 }}

                    >
                    <span onClick={() => setRegionIndex(0)}>&#61751;</span>

                    {
                        regions.find(r => r.id === regionIndex)?.citiesdata?.map((city, index2) => (

                            <motion.div
                                key={index2}
                                className="button"
                                initial={{opacity: 0, x: 1000}}
                                animate={showItems ? {opacity: 1, x: 0} : {}}
                                transition={{delay: index2 * 0.1, duration: 0.3}}

                            >{city.name}</motion.div>

                        ))

                    }
                    </motion.div>
                )


            }
                </AnimatePresence>
            </motion.section>
        )


}

export default Regions;